module.exports = __webpack_public_path__ + "static/media/main18.47166384.png";